/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type OrderAdjustmentPaginatedProperty =
  typeof OrderAdjustmentPaginatedProperty[keyof typeof OrderAdjustmentPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderAdjustmentPaginatedProperty = {
  DUE_DATE: 'DUE_DATE',
  BANK_NAME: 'BANK_NAME',
  ADJUSTMENT_TYPE: 'ADJUSTMENT_TYPE',
} as const;
